import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import services from "../services";
import constant from "../constant";
import "./WhatsAppConnectSheet.css";

// Screens where the sheet would get in the way
const HIDDEN_ON = ["/register", "/terms", "/privacy"];

const STEPS = [
  { icon: "fas fa-hand-pointer", text: "Tap the button" },
  { icon: "fas fa-paper-plane", text: "Send the “Hi”" },
  { icon: "fas fa-headset", text: "Support saved" },
];

const openWhatsApp = () => {
  const url = `https://wa.me/${constant.WHATSAPP_SUPPORT_NUMBER}?text=${encodeURIComponent("Hi")}`;
  // In the app, navigating to an external link hands it to the OS, which opens WhatsApp
  if (Capacitor.isNativePlatform()) window.location.href = url;
  else window.open(url, "_blank", "noopener");
};

// Asks the partner to message us on WhatsApp. Shown on every app open until they tap the button.
export default function WhatsAppConnectSheet() {
  const { pathname } = useLocation();
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (checked || HIDDEN_ON.some((p) => pathname.startsWith(p))) return;
    setChecked(true);
    services.Vendor.GET_VENDOR()
      .then((res) => {
        if (res?.data?.VendorDetail && !res.data.VendorDetail.whatsappConnectTappedAt) setOpen(true);
      })
      .catch(() => {});
  }, [pathname, checked]);

  if (!open || HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  const onConnect = () => {
    services.Vendor.WHATSAPP_CONNECT().catch(() => {});
    setOpen(false);
    openWhatsApp();
  };

  return (
    <div className="wa-sheet-backdrop" onClick={() => setOpen(false)}>
      <div className="wa-sheet" role="dialog" aria-labelledby="wa-sheet-title" onClick={(e) => e.stopPropagation()}>
        <div className="wa-sheet-grip" />
        <button className="wa-sheet-close" aria-label="Close" onClick={() => setOpen(false)}>
          <i className="fas fa-times" />
        </button>

        <div className="wa-sheet-hero">
          <span className="wa-sheet-bubble wa-sheet-bubble-in">Need help?</span>
          <span className="wa-sheet-logo"><i className="fab fa-whatsapp" /></span>
          <span className="wa-sheet-bubble wa-sheet-bubble-out">Hi 👋</span>
        </div>

        <h3 id="wa-sheet-title">Your Cars53 support, on WhatsApp</h3>
        <p className="wa-sheet-sub">
          Bookings, payments or account questions: our partner team is just one message away.
        </p>
        <p className="wa-sheet-hi">WhatsApp पर “Hi” भेजें और सपोर्ट टीम से सीधे जुड़ें।</p>

        <div className="wa-sheet-steps">
          {STEPS.map((s, i) => (
            <div className="wa-sheet-step" key={s.text}>
              <span className="wa-sheet-step-icon"><i className={s.icon} /></span>
              <span><b>{i + 1}.</b> {s.text}</span>
            </div>
          ))}
        </div>

        <button className="wa-sheet-btn" onClick={onConnect}>
          <i className="fab fa-whatsapp" /> Say Hi on WhatsApp
        </button>
        <button className="wa-sheet-later" onClick={() => setOpen(false)}>Maybe later</button>
      </div>
    </div>
  );
}
